// extracted by extract-css-chunks-webpack-plugin
module.exports = {"close":"_1EHECy","btn":"_20jDGw hzeKHv _3Ta8Hy _2buisT HT3Wis","content":"_21pvEF","overlay":"_1asYNe"};